import React from 'react';
import AntdTabs from "antd/lib/tabs";
import {DeclaredComponent} from "../DynamicComponent";

const { TabPane } = AntdTabs;

export function Tabs({items}) {

  if (!items.length) {
    return null;
  }

  return <AntdTabs defaultActiveKey={items[0].route} onChange={() => {}}>
    {items.map(tab => <TabPane tab={tab.title} key={tab.route}>
      <DeclaredComponent declaration={tab.content}/>
    </TabPane>)}
  </AntdTabs>;
}